import { log } from 'three/examples/jsm/nodes/Nodes.js'
;(function (w, $) {
    'use strict'

    // Lookup Wallet address by gmail
    function lookups(email) {
        return new Promise((resolve, reject) => {
            var postData = { email: email }

            $.ajax({
                type: 'POST',
                url: './admin/web_api/lookups.php',
                contentType: 'application/json; charset=UTF-8',
                data: JSON.stringify(postData),
                dataType: 'json',
                success: function (response) {
                    if (response.code > 0) {
                        console.log('user address get success!')

                        collections(response.data.address)
                            .then((array_point_get) => {
                                // 成功
                                resolve({ address: response.data.address, array_point_get })
                            })
                            .catch((error) => {
                                reject(error)
                            })
                    } else {
                        // 失敗
                        reject(response.error || '查找失敗！')
                    }
                },
                error: function (data) {
                    // 錯誤
                    reject(data)
                },
            })
        })
    }

    // Claim NFT
    function claim(email, address, poolid) {
        var $this = $(event.currentTarget)

        var postData = {}
        postData.email = email
        postData.address = address
        postData.poolid = poolid

        $.ajax({
            type: 'POST',
            url: './admin/web_api/claim.php',
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify(postData),
            dataType: 'json',
            success: function (response) {
                if (response.code > 0) {
                    if (response.data.isEnrolled == true && response.data.isSoldOut == false) {
                        // 成功
                        $this.next('div').text(JSON.stringify(response.data))
                    } else if (response.data.isEnrolled == false && response.data.isSoldOut == false) {
                        $this.next('div').text(JSON.stringify('您已經領過了！'))
                    } else if (response.data.isInvalid == true) {
                        $this.next('div').text(JSON.stringify('參數錯誤！'))
                    }
                } else {
                    alert(response.error || '取得失敗！')
                }
            },
            error: function (data) {
                console.log(data)
            },
        })
    }

    // buy NFT
    function buy(address, poolid) {
        var onloaded = function () {
            console.log('onloaded')
        }

        var onclose = function () {
            console.log('onclose')
        }

        var onerror = function (e) {
            console.log(e)
        }

        buyNFT(address, poolid, onloaded, onclose, onerror)
    }

    // Get collections by address
    function collections(address) {
        return new Promise((resolve, reject) => {
            var $this = $(event.currentTarget)

            var postData = {}
            postData.address = address

            $.ajax({
                type: 'POST',
                url: './admin/web_api/collections.php',
                contentType: 'application/json; charset=UTF-8',
                data: JSON.stringify(postData),
                dataType: 'json',
                success: function (response) {
                    if (response.code > 0) {
                        console.log('user collections get success!')

                        // 初始化 array_point_get
                        let array_point_get = [false, false, false, false, false, false]

                        // 成功
                        if (response.data.tokens.length > 0) {
                            array_point_get[0] = response.data.tokens.some(function (item) {
                                return item.tokenId === 26024
                            })
                            console.log('Is L get:', array_point_get[0])

                            array_point_get[1] = response.data.tokens.some(function (item) {
                                return item.tokenId === 26023
                            })
                            console.log('Is E1 get:', array_point_get[1])

                            array_point_get[2] = response.data.tokens.some(function (item) {
                                return item.tokenId === 26022
                            })
                            console.log('Is E2 get:', array_point_get[2])

                            array_point_get[3] = response.data.tokens.some(function (item) {
                                return item.tokenId === 26021
                            })
                            console.log('Is C get:', array_point_get[3])

                            array_point_get[4] = response.data.tokens.some(function (item) {
                                return item.tokenId === 26020
                            })
                            console.log('Is O get:', array_point_get[4])

                            array_point_get[5] = response.data.tokens.some(function (item) {
                                return item.tokenId === 26025
                            })
                            console.log('Is lottery get:', array_point_get[5])
                        } else {
                            console.log('No tokens found.')
                        }

                        resolve(array_point_get)
                    } else {
                        alert(response.error || '取得失敗！')
                        reject(response.error || '取得失敗！')
                    }
                },
                error: function (data) {
                    console.log(data)
                    reject(data)
                },
            })
        })
    }

    w.onerror = function (message, source, lineno, colno, error) {
        if (error && source && lineno) {
            try {
                var errorMessage = 'JavaScript Error: ' + message + ' in ' + source + ' on line ' + lineno + ':' + colno
                alert(errorMessage)
            } catch (e) {
                console.log(e)
            }
        }
        return false
    }

    w.lookups = lookups
    w.claim = claim
    w.buy = buy
    w.collections = collections
})(window, window.jQuery)
